import { predictorData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    predictorData
  }
};
